import { routerMiddleware } from "connected-react-router";
import { createBrowserHistory } from "history";
import { IndexHumboldt, AppInfo } from "humboldt";
import { applyMiddleware, compose, createStore } from "redux";
import * as authActions from "../auth/actions";
import { storage } from "../auth/utils/index";
import { VERSION } from "../gen/version";
import { rootReducer } from "../root/rootReducer";

const appInfo: AppInfo = {
    hardwareId: navigator.userAgent,
    deviceUUID: storage.getItem(storage.USER_BROWSER_ID),
    appVersion: VERSION,
    userAgent: navigator.userAgent,
};

export const history = createBrowserHistory();

function configureStore() {
    return createStore(
        rootReducer(history),
        compose(
            applyMiddleware(
                routerMiddleware(history), // for dispatching history actions
                // ... other middlewares ...
            ),
        ),
    );
}

export const store = configureStore();

export async function checkAndReturnToken(): Promise<string> {
    // Check if our access token expired
    const FUDGE_FACTOR_IN_MILLIS = 30 * 1000; // #arbitrary
    const state = store.getState();
    const { expireDate } = state.auth;

    const isAccessTokenExpired = new Date().getTime() > (expireDate.getTime() + FUDGE_FACTOR_IN_MILLIS);
    if (isAccessTokenExpired) {
        console.log("Access Token Expired. Renewing Token");
        await authActions.renewToken(store.dispatch);
    }

    if (state.auth?.accessToken) {
        return state.auth.accessToken;
    } else {
        throw new Error("auth can't be undefined here");
    }
}

export function getHumboldt(): IndexHumboldt {
    const humboldt = new IndexHumboldt(checkAndReturnToken, appInfo, false);
    return humboldt;
}
